module.exports = __webpack_public_path__ + "img/cmed-instuctor.0ea6803d.png";